import { batch } from "react-redux";
import { decimalPoints } from "../constants/constants";
import { mainViewSectionCombinations } from "../constants/componentMap";
import { generateStudyIdAndTimeStamp } from "../constants/utilityFunctions";
import {
  fetchSetProtocol,
  fetchSetLocation,
  setSampleAlert,
  fetchCloseDevice,
} from "../actions";

// DIALOG TOGGLES
export const TOGGLE_LOAD_DIALOG = "TOGGLE_LOAD_DIALOG";
export function toggleLoadDialog() {
  return {
    type: TOGGLE_LOAD_DIALOG,
  };
}

export const TOGGLE_SAVE_DIALOG = "TOGGLE_SAVE_DIALOG";
export function toggleSaveDialog() {
  return {
    type: TOGGLE_SAVE_DIALOG,
  };
}
export const TOGGLE_QUIT_STUDY_DIALOG = "TOGGLE_QUIT_STUDY_DIALOG";
export function toggleQuitDialog() {
  return {
    type: TOGGLE_QUIT_STUDY_DIALOG,
  };
}
export const TOGGLE_LOCK_DIALOG = "TOGGLE_LOCK_DIALOG";
export function toggleLockDialog() {
  return {
    type: TOGGLE_LOCK_DIALOG,
  };
}

export const TOGGLE_PROTOCOL_DIALOG = "TOGGLE_PROTOCOL_DIALOG";
export function toggleProtocolDialog() {
  return {
    type: TOGGLE_PROTOCOL_DIALOG,
  };
}

export const TOGGLE_EXPORT_PDF_DIALOG = "TOGGLE_EXPORT_PDF_DIALOG";
export function toggleExportPdfDialog() {
  return {
    type: TOGGLE_EXPORT_PDF_DIALOG,
  };
}

export const TOGGLE_EXPORT_CSV_DIALOG = "TOGGLE_EXPORT_CSV_DIALOG";
export function toggleExportCsvDialog() {
  return {
    type: TOGGLE_EXPORT_CSV_DIALOG,
  };
}

export const TOGGLE_WIFI_DIALOG = "TOGGLE_WIFI_DIALOG";
export function toggleWifiDialog() {
  return {
    type: TOGGLE_WIFI_DIALOG,
  };
}
export const TOGGLE_EXPORT_STUDIES_DIALOG = "TOGGLE_EXPORT_STUDIES_DIALOG";
export function toggleExportStudiesDialog() {
  return {
    type: TOGGLE_EXPORT_STUDIES_DIALOG,
  };
}

export const TOGGLE_EXISTING_PARTICIPANTS_DIALOG =
  "TOGGLE_EXISTING_PARTICIPANTS_DIALOG";
export function toggleExistingParticipantsDialog() {
  return {
    type: TOGGLE_EXISTING_PARTICIPANTS_DIALOG,
  };
}
export const TOGGLE_SYNC_STUDIES_DIALOG = "TOGGLE_SYNC_STUDIES_DIALOG";
export function toggleSyncStudiesDialog() {
  return {
    type: TOGGLE_SYNC_STUDIES_DIALOG,
  };
}
export const TOGGLE_DIAGNOSTICS_DIALOG = "TOGGLE_DIAGNOSTICS_DIALOG";
export function toggleDiagnosticsDialog() {
  return {
    type: TOGGLE_DIAGNOSTICS_DIALOG,
  };
}

// MODES
export const TOGGLE_EDIT_MAP_MODE = "TOGGLE_EDIT_MAP_MODE";
export function toggleEditMapMode() {
  return {
    type: TOGGLE_EDIT_MAP_MODE,
  };
}

export const TOGGLE_REMOVE_LOCATION_MODE = "TOGGLE_REMOVE_LOCATION_MODE";
export function toggleRemoveLocationMode() {
  return {
    type: TOGGLE_REMOVE_LOCATION_MODE,
  };
}

export const TOGGLE_ADD_NEW_LOCATION_MODE = "TOGGLE_ADD_NEW_LOCATION_MODE";
export function toggleAddNewLocationMode() {
  return {
    type: TOGGLE_ADD_NEW_LOCATION_MODE,
  };
}

// OTHER
export const TOGGLE_SHOW_COMPLETED = "TOGGLE_SHOW_COMPLETED";
export function toggleShowCompleted() {
  return {
    type: TOGGLE_SHOW_COMPLETED,
  };
}

export const TOGGLE_HEATMAP = "TOGGLE_HEATMAP";
export function toggleHeatmap() {
  return {
    type: TOGGLE_HEATMAP,
  };
}

export const SET_HEATMAP_TYPE = "SET_HEATMAP_TYPE";
export function setHeatmapType(heatmapType) {
  return {
    type: SET_HEATMAP_TYPE,
    heatmapType: heatmapType,
  };
}
export const SET_HEATMAP_LIMIT = "SET_HEATMAP_LIMIT";
export function setHeatmapLimit(newLimits) {
  return {
    type: SET_HEATMAP_LIMIT,
    swsLimit: newLimits.swsLimit,
    thicknessLimit: newLimits.thicknessLimit,
  };
}

export const SET_THEME = "SET_THEME";
export function setTheme() {
  return {
    type: SET_THEME,
  };
}

export const SET_MAIN_VIEW_SECTION = "SET_MAIN_VIEW_SECTION";
export function setMainViewSection(mainViewSectionComboId) {
  return {
    type: SET_MAIN_VIEW_SECTION,
    orientation:
      mainViewSectionCombinations[mainViewSectionComboId].orientation,
    columnOne: mainViewSectionCombinations[mainViewSectionComboId].columnOne,
    columnTwo: mainViewSectionCombinations[mainViewSectionComboId].columnTwo,
    columnThree:
      mainViewSectionCombinations[mainViewSectionComboId].columnThree,
    columnFour: mainViewSectionCombinations[mainViewSectionComboId].columnFour,
  };
}

export const SET_STUDY_NOTE = "SET_STUDY_NOTE";
export function setStudyNote(text) {
  return {
    type: SET_STUDY_NOTE,
    text,
  };
}

export const SET_VIEW = "SET_VIEW";
export function setView(viewId) {
  return {
    type: SET_VIEW,
    viewId,
  };
}

export const SET_VIRTUAL_KEYBOARD = "SET_VIRTUAL_KEYBOARD";
export function setVirtualKeyboard(state) {
  return {
    type: SET_VIRTUAL_KEYBOARD,
    state,
  };
}

export const TOGGLE_VIRTUAL_KEYBOARD_ALLOWED =
  "TOGGLE_VIRTUAL_KEYBOARD_ALLOWED";
export function toggleVirtualKeyboardAllowed() {
  return {
    type: TOGGLE_VIRTUAL_KEYBOARD_ALLOWED,
  };
}

export const SET_SAVE_AND_QUIT = "SET_SAVE_AND_QUIT";
export function setSaveAndQuit(status) {
  return {
    type: SET_SAVE_AND_QUIT,
    status: status,
  };
}

export const ERROR_RESPONSE = "ERROR_RESPONSE";
export function errorResponse(error) {
  var errorInfo;
  if (error.response) {
    // Request made and server responded
    errorInfo = error.response.data.error;
  } else {
    // Error occured in setting up the request ex. no server was running
    if (error.message) {
      errorInfo = error.message;
    } else {
      errorInfo = error;
    }
  }
  return {
    type: ERROR_RESPONSE,
    error: errorInfo,
  };
}

export const RESET_ERROR = "RESET_ERROR";
export function resetError() {
  return {
    type: RESET_ERROR,
  };
}

export const RESET_REDUX = "RESET_REDUX";
export function resetRedux(keepUser) {
  return {
    type: RESET_REDUX,
    keepUser,
  };
}

export const RESET_SAVE_STUDY = "RESET_SAVE_STUDY";
export function resetSaveStudy() {
  return {
    type: RESET_SAVE_STUDY,
  };
}

export const RESET_SUCCESS = "RESET_SUCCESS";
export function resetSuccess() {
  return {
    type: RESET_SUCCESS,
  };
}

export const SET_LOCAL_FOLDERPATH = "SET_LOCAL_FOLDERPATH";
export function setLocalFilepath(localFolderpath) {
  return {
    type: SET_LOCAL_FOLDERPATH,
    localFolderpath,
  };
}

export const SET_CURRENT_ACQ_TYPE = "SET_CURRENT_ACQ_TYPE";
export function setCurrentAcqType(acqType) {
  return {
    type: SET_CURRENT_ACQ_TYPE,
    acqType,
  };
}

// removes sample for an empty (canceled) photo sample
export const CANCEL_PHOTO = "CANCEL_PHOTO";
export function cancelPhoto(sampleId) {
  return {
    type: CANCEL_PHOTO,
    sampleId: sampleId,
  };
}

export const SET_LOCATION_ALERT = "SET_LOCATION_ALERT";
export function setLocationAlert(locationId, alert, sampleIncludedInStudy) {
  return {
    type: SET_LOCATION_ALERT,
    locationId: locationId,
    alert: alert,
    sampleIncludedInStudy: sampleIncludedInStudy,
  };
}

// update the overall study progress
export const SET_STUDY_PROGRESS = "SET_STUDY_PROGRESS";
export function setStudyProgress(newProgress) {
  return {
    type: SET_STUDY_PROGRESS,
    newProgress: newProgress,
  };
}

// update studyInfo for study
export const ADD_STUDY_INFO = "ADD_STUDY_INFO";
export function addStudyInfo(studyInfo, studyId) {
  return {
    type: ADD_STUDY_INFO,
    id: studyId,
    protocolId: studyInfo.protocolId,
    participantId: studyInfo.participantId,
    skinType: studyInfo.skinType,
    gender: studyInfo.gender,
    birthYear: studyInfo.birthYear,
    protocolName: studyInfo.protocolName,
    startedAt: studyInfo.startedAt,
    studyDate: studyInfo.studyDate,
    otherId: studyInfo.otherId,
  };
}

export const SUCCESS_RESPONSE = "SUCCESS_RESPONSE";
export function successResponse(message) {
  return { type: SUCCESS_RESPONSE, message: message };
}

export const WARNING_RESPONSE = "WARNING_RESPONSE";
export function warningResponse(message) {
  return { type: WARNING_RESPONSE, message: message };
}

export const RESET_WARNING = "RESET_WARNING";
export function resetWarning() {
  return {
    type: RESET_WARNING,
  };
}

export const OPEN_RESULT_SNACKBAR = "OPEN_RESULT_SNACKBAR";
export function openResultSnackbar(data, sampleType) {
  let value = null;
  if (data !== null) {
    value = data.toFixed(decimalPoints);
  }
  return {
    type: OPEN_RESULT_SNACKBAR,
    value: value,
    sampleType: sampleType,
  };
}

export const RESET_RESULT_SNACKBAR = "RESET_RESULT_SNACKBAR";
export function resetResultSnackbar() {
  return {
    type: RESET_RESULT_SNACKBAR,
  };
}

// update position of selector triangle (for locations menu)
export const SET_SELECTOR_POSITION = "SET_SELECTOR_POSITION";
export function setSelectorPosition(position) {
  return {
    type: SET_SELECTOR_POSITION,
    position: position,
  };
}

export const SET_NEXT_AUTO_STEP = "SET_NEXT_AUTO_STEP";
export function setNextAutoStep(locationId, acqType, form) {
  return {
    type: SET_NEXT_AUTO_STEP,
    locationId: locationId,
    acqType: acqType,
    form: form,
  };
}

export const SET_CREATE_PROTOCOL_MODE = "SET_CREATE_PROTOCOL_MODE";
export function setCreateProtocolMode(status) {
  return {
    type: SET_CREATE_PROTOCOL_MODE,
    status: status,
  };
}

export const SET_FOCUS_ELEMENT = "SET_FOCUS_ELEMENT";
export function setFocusElement(id) {
  return {
    type: SET_FOCUS_ELEMENT,
    id,
  };
}

export const TOGGLE_ACQUIRE_BAR = "TOGGLE_ACQUIRE_BAR";
export function toggleAcquireBar() {
  return {
    type: TOGGLE_ACQUIRE_BAR,
  };
}

export const TOGGLE_REVIEW_HEATMAP = "TOGGLE_REVIEW_HEATMAP";
export function toggleReviewHeatmap() {
  return {
    type: TOGGLE_REVIEW_HEATMAP,
  };
}

export const SET_REVIEW_HEATMAP_TYPE = "SET_REVIEW_HEATMAP_TYPE";
export function setReviewHeatmapType(reviewHeatmapType) {
  return {
    type: SET_REVIEW_HEATMAP_TYPE,
    reviewHeatmapType: reviewHeatmapType,
  };
}

export const TOGGLE_REVIEW_FILTER_DRAWER = "TOGGLE_REVIEW_FILTER_DRAWER";
export function toggleReviewFilterDrawer() {
  return {
    type: TOGGLE_REVIEW_FILTER_DRAWER,
  };
}

export const TOGGLE_NOTES_FOCUS = "TOGGLE_NOTES_FOCUS";
export function toggleNotesFocus() {
  return {
    type: TOGGLE_NOTES_FOCUS,
  };
}

export const TOGGLE_DISABLED = "TOGGLE_DISABLED";
export function toggleDisabled(sampleId) {
  return {
    type: TOGGLE_DISABLED,
    id: sampleId,
  };
}

export const TOGGLE_LOCK = "TOGGLE_LOCK";
export function toggleLock() {
  return {
    type: TOGGLE_LOCK,
  };
}

export const TOGGLE_SKIP_DIAGNOSTICS_SETUP = "TOGGLE_SKIP_DIAGNOSTICS_SETUP";
export function toggleSkipDiagnosticsSetup() {
  return {
    type: TOGGLE_SKIP_DIAGNOSTICS_SETUP,
  };
}

//////////////////////////// AUTO ADVANCE //////////////////////////////////////
export const SET_AUTO_ADVANCE_SNACKBAR_STATE =
  "SET_AUTO_ADVANCE_SNACKBAR_STATE";
export function setAutoAdvanceSnackbarState(state) {
  return {
    type: SET_AUTO_ADVANCE_SNACKBAR_STATE,
    state,
  };
}

export const TOGGLE_AUTO_ADVANCE = "TOGGLE_AUTO_ADVANCE";
export function toggleAutoAdvance() {
  return {
    type: TOGGLE_AUTO_ADVANCE,
  };
}

export const SET_AUTO_ADVANCE_DIALOG_STATE = "SET_AUTO_ADVANCE_DIALOG_STATE";
export function setAutoAdvaceDialogState(state) {
  return {
    type: SET_AUTO_ADVANCE_DIALOG_STATE,
    state,
  };
}

export function changeAcqType(acqType) {
  return (dispatch, getState) => {
    const selectedLocationId = getState().locations.selectedLocationId;
    dispatch(setCurrentAcqType(acqType)); // update the redux currentAcqType
    dispatch(fetchSetLocation(selectedLocationId, acqType)); // update current_location param on server
  };
}

// checks study protocol samplesRequried for each location
// if samplesRequired is > 0 for any location, auto-advance is enabled
export function initiateAutoAdvance() {
  return (dispatch, getState) => {
    let state = getState();
    const locations = state.locations.byId;
    let autoAdvance = false;

    state.locations.allIds.forEach((locationId) => {
      const location = locations[locationId];
      Object.keys(state.protocol.acq_types).forEach((type) => {
        if (location.samplesNeeded[type] > 0) {
          autoAdvance = true;
        }
      });
    });

    if (autoAdvance) {
      dispatch(toggleAutoAdvance());
    }
  };
}

export function calculateStudyProgress() {
  return (dispatch, getState) => {
    let state = getState();
    const totalSamplesNeeded = state.studyInfo.totalSamplesNeeded;
    // calculate total samples acquired for all locations
    let totalSamplesAcquired = 0;
    for (let locationId of state.locations.allIds) {
      // For each location thats NOT removed from study
      if (!state.protocol.locations[locationId].removed) {
        for (let acq_type of Object.keys(state.protocol.acq_types)) {
          const samplesNeeded =
            state.locations.byId[locationId].samplesNeeded[acq_type];
          const samplesAcquired =
            state.locations.byId[locationId].samplesAcquired[acq_type];

          if (samplesAcquired < samplesNeeded) {
            totalSamplesAcquired += samplesAcquired;
          } else {
            totalSamplesAcquired += samplesNeeded;
          }
        }
      }
    }
    const newProgress = Math.round(
      (totalSamplesAcquired / totalSamplesNeeded) * 100
    );
    dispatch(setStudyProgress(newProgress));
    // If all required samples are acquired then switch on the bodymap heatmap
    if (newProgress === 100 && !state.utility.heatmap.status) {
      dispatch(toggleHeatmap());
    }
  };
}
export function updateSampleAlert(sampleId, alert) {
  return (dispatch, getState) => {
    let sample = getState().samples.byId[sampleId];
    // If alert status is true then add the alert type to the sample's alert if the alert type is not already added
    if (
      alert["status"] === true &&
      !sample.alert.type.includes(alert["type"])
    ) {
      dispatch(setSampleAlert(sampleId, alert));
      dispatch(updateLocationAlert(sample.locationId));
    } else if (
      alert["status"] === false &&
      alert["type"] !== null &&
      sample.alert.type.includes(alert["type"])
    ) {
      // remove an existing sample alert from the sample
      dispatch(setSampleAlert(sampleId, alert));
      dispatch(updateLocationAlert(sample.locationId));
    } else if (alert["status"] === false && sample.type === "BMODE") {
      // remove an existing sample alert from the sample
      dispatch(setSampleAlert(sampleId, alert));
      dispatch(updateLocationAlert(sample.locationId));
    }
  };
}

export function updateLocationAlert(locationId) {
  return (dispatch, getState) => {
    //Check if alert samples for the location are includedInStudy
    let alertIncluded = 0;
    let alertSamples = 0;
    let locationSamples = getState().locations.byId[locationId].samples;

    for (let sampleIndex in locationSamples) {
      let sample = getState().samples.byId[locationSamples[sampleIndex]];
      if (sample.alert.state) {
        alertSamples = alertSamples + 1;
        if (sample.includeInStudy) {
          alertIncluded = alertIncluded + 1;
        }
      }
    }
    dispatch(setLocationAlert(locationId, alertSamples > 0, alertIncluded > 0));
  };
}

export function checkAutoAdvance() {
  return (dispatch, getState) => {
    let state = getState();
    const locationId = state.locations.selectedLocationId;
    const location = state.locations.byId[locationId];
    const acqTypes = Object.keys(state.protocol.acq_types);
    // Check auto-advance
    if (state.utility.autoAdvance && state.device.connectionEstablished) {
      // SWITCH LOCATION
      if (location.completed) {
        // find next location that needs acquisitions
        const locations = state.locations.allIds;
        const startIndex = locations.indexOf(locationId);
        let index = startIndex;
        let samplesNeededTotal = 0;
        do {
          samplesNeededTotal = 0;
          // if we're not to the end of the locations array
          if (index < locations.length - 1) {
            // advance to next location in locations array
            index++;
          } else {
            // loop back to the start of the array
            index = 0;
          }
          // once we've looped through the entire array we're done with all required acquisitions!
          if (index === startIndex) {
            break;
          }
          for (let acqTypeId in state.protocol.acq_types) {
            samplesNeededTotal +=
              state.locations.byId[locations[index]].samplesNeeded[acqTypeId];
          }
        } while (
          // keep looping through if the location is completed OR if it is removed from study
          state.locations.byId[locations[index]].completed ||
          state.protocol.locations[locations[index]].removed ||
          samplesNeededTotal === 0
        );

        const nextLocationId = locations[index];
        //Ignore if all required data is obtained
        if (!state.locations.byId[nextLocationId].completed) {
          let nextAcqType = null;
          // Switch to the acqType that the new location has not completed

          for (let acqTypeId in state.protocol.acq_types) {
            if (
              state.locations.byId[nextLocationId].samplesAcquired[acqTypeId] <
                state.locations.byId[nextLocationId].samplesNeeded[acqTypeId] &&
              state.locations.byId[nextLocationId].samplesNeeded[acqTypeId] !==
                0
            ) {
              nextAcqType = acqTypeId;
              break;
            }
          }
          dispatch(setNextAutoStep(nextLocationId, nextAcqType, "LOCATION"));
          dispatch(setAutoAdvaceDialogState(true));
        }
      } else if (
        state.utility.autoAdvance &&
        location.samplesAcquired[state.locations.currentAcqType] >=
          location.samplesNeeded[state.locations.currentAcqType] &&
        location.samplesNeeded[state.locations.currentAcqType] !== 0
      ) {
        //move to next acq type
        const startIndex = acqTypes.indexOf(state.locations.currentAcqType);
        let index = startIndex;
        do {
          // if we're not to the end of the acq_types array
          if (index < acqTypes.length - 1) {
            // advance to next acq_type
            index++;
          } else {
            // loop back to the start of the array
            index = 0;
          }
          // once we've looped through the entire array we're done
          if (index === startIndex) {
            break;
          }
        } while (
          location.samplesAcquired[acqTypes[index]] >=
          location.samplesNeeded[acqTypes[index]]
        );
        // If its the same acqType then there is no need for the autoadvance
        if (acqTypes[index] !== state.locations.currentAcqType) {
          dispatch(setNextAutoStep(locationId, acqTypes[index], "TYPE"));
          dispatch(setAutoAdvanceSnackbarState(true));
        }
      }
    }
  };
}

export function createNewStudy(studyInfo) {
  return (dispatch) => {
    let studyStamps = generateStudyIdAndTimeStamp();

    studyInfo["startedAt"] = studyStamps.startedAt;
    studyInfo["studyDate"] = studyStamps.studyDate;
    batch(() => {
      dispatch(addStudyInfo(studyInfo, studyStamps.id)); // add studyInfo to the redux state tree
      dispatch(
        fetchSetProtocol(
          studyInfo.protocolId,
          studyStamps.id,
          studyInfo.participantId
        )
      ); // set the chosen protocol and change view
    });
  };
}

export function discardStudy(prompt) {
  return (dispatch, getState) => {
    // If device is open then close device before discarding quitting
    if (getState().device.connectionEstablished) {
      dispatch(fetchCloseDevice("QUIT"));
    }
    // Reset redux
    if (prompt === "QUIT") {
      dispatch(resetRedux(true)); // set all of the reducer slices to intialState EXCEPT user info
    } else if (prompt === "LOGOUT") {
      localStorage.setItem("username", null);
      localStorage.setItem("password", null);
      dispatch(resetRedux(false)); // set all of the reducer slices to intialState
    }
  };
}
